/* 学习乐园 · 五子棋棋谱复盘（/study/wuziqi-fupan）
 * 与国际象棋 / 中国象棋复盘同构，但独立成页——规则、引擎、记谱互不通用：
 *   - 引擎直接复用对战页内置的 STWuziqi（footer 按 engine='wuziqi' 先载入 game-wuziqi.js；
 *     对战页的 boot() 在复盘页找不到 [data-st-game] 会自行退出，无副作用）；
 *   - 输入是本站导出/复制的文本棋谱（`1. 黑 H8` 一行一手），整行坐标对（H8-I9）也认；
 *     五子棋没有像 PGN 那样的事实标准，不冒充统一格式（口径同象棋复盘）；
 *   - 分差口径（与两个象棋复盘「最强应着分」同构，按五子棋引擎的真实构造定制）：
 *     五子棋引擎没有全局局面分，只有点评估——「(x,y) 落 color 的威胁分」。
 *     所以局面分定义为：轮走方在该局面下最优点的「综合分」= 自己的进攻威胁(myGain)
 *     + 对手在同点的威胁(oppGain)——能成五的点、必须堵的点都会被它顶上去。
 *     第 k 手亏损 = 最优点的综合分 − 实际那手的综合分。亏分再拆两个分量：
 *     进攻亏（自己的连子机会没抓住）与防守亏（对手的威胁没堵住），报告照实说。
 *   - 复盘页自带 rankMoves（点综合分排序 + 终局短路，确定性、无随机抖动、无展望层），
 *     引擎文件零改动（改引擎 = 给已上线对战页引入回归风险）；「亏了多少」和
 *     「该走哪」出自同一份计算，与象棋复盘同一铁律。
 *   - 分析是纯点评估（无深度搜索），整盘毫秒级：不需要进度条、不需要分拍切片，
 *     同步算完直接出报告——这是与两个象棋复盘唯一的流程差异。
 *   - 无评估条：威胁分数量纲与胜负概率没有可换算的关系，硬换算就是伪精确
 *     （对战页同为无评估条，同一决策）；局面状态用「回看到第几手 + 这手形成什么」表达。
 * 全程在浏览器本地完成：解析、评分、报告都不发网络请求。 */
(function (global) {
  'use strict';

  var doc = global.document;
  var E = global.STWuziqi;   // 对战页引擎（footer 先载入 game-wuziqi.js，boot 时已就位）
  var UI = null;

  /* 页面判定：复盘页容器 + 棋盘都在才接管 DOM；Node 冒烟直调钩子时没有 document，
     模块加载必须零 DOM 副作用（与 game-wuziqi.js 的 boot 防呆同口径）。 */
  var root = doc ? doc.querySelector('[data-st-wuziqi-fupan]') : null;
  var pageOn = !!(root && doc.querySelector('[data-st-board]'));
  if (!pageOn && !E) { return; }   // Node 里没先载引擎：钩子挂不上，冒烟脚本会看到 undefined
  if (pageOn && !E) {
    var showEngineError = function () {
      var box = doc.querySelector('[data-st-status]');
      if (box) { box.textContent = '五子棋引擎没有加载上（本机静态文件读取失败）。刷新一次通常就好。'; }
    };
    if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', showEngineError); }
    else { showEngineError(); }
    return;
  }

  var N = E.N;               // 15
  var FILES = E.FILES;       // 列名 A~O（含 I）
  var SCORES = E.SCORES;
  /* 结论门槛：五子棋分数量纲是威胁档位（活三 5 万 / 冲四 10 万 / 活四 100 万 / 成五 1000 万）。
     漏堵活三是五子棋最常见的输棋原因，必须列进结论；眠三级（2000）及以下的差别不列。 */
  var REPORT_MIN = 20000;    // 结论门槛：错着（活三档的一半，漏活三必中）
  var KIND_MIN = { blunder: 100000, mistake: 20000, inaccuracy: 5000 };
  var KIND_CN = { blunder: '漏着', mistake: '错着', inaccuracy: '不精确' };

  var STORE_KEY = 'study-wuziqi-fupan-report';
  var HANDOFF_KEY = 'study-wuziqi-fupan-handoff';
  var HIST_KEY = 'study-wuziqi-fupan-history';
  var HIST_MAX = 5;          // 最近棋谱留几盘（口径同两个象棋复盘）

  /* ---------- 状态 ---------- */
  var moves = [];        // [{x, y, color}]，color 1=黑 2=白（第 1 手必黑，由步序决定）
  var plies = [];        // [{coord, mover, x, y, explain, loss, kind, whySide}]
  var scores = [];       // scores[k] = 第 k 手之前局面里轮走方最优点的综合分
  var bests = [];        // bests[k] = 该局面引擎建议着 {x, y, coord}（榜首，= 同一次计算）
  var tops = [];         // tops[k] = 综合分榜 [{coord, s, gap}]（备选的来源）
  var pvs = {};          // pvs[k] = 该局面的参考变化（坐标数组，点「看变化」才算，缓存）
  var viewAt = null;     // null = 终局；数字 = 看到「第 viewAt+1 手之后」的局面（0 起）
  var analyzed = false;
  var analyzing = false;
  var replayTimer = null;
  var savedNote = '';
  var lastCued = null;   // 最近一次播落子声的 viewAt：只在回看位置变化时响
  var setStatus = function () {};

  /* ---------- 棋盘（只读，15×15 格子与对战页同一套 DOM 结构与样式类） ---------- */
  function buildBoard() {
    var frag = doc.createDocumentFragment();
    for (var y = 0; y < N; y++) {
      for (var x = 0; x < N; x++) {
        var c = doc.createElement('button');
        c.type = 'button';
        c.className = 'st-wz-cell';
        c.disabled = true;                       // 复盘棋盘只读：disabled 连悬停预览都不触发
        c.dataset.pos = E.coordName(x, y);
        c.setAttribute('aria-label', '第' + (y + 1) + '行 ' + FILES.charAt(x) + '列（' + E.coordName(x, y) + '）');
        var stone = doc.createElement('span');
        stone.className = 'st-wz-stone';
        c.appendChild(stone);
        frag.appendChild(c);
      }
    }
    UI.board.textContent = '';
    UI.board.appendChild(frag);
  }
  /* 前 k 手之后的局面（重放，与对战页同一套路） */
  function boardAt(k) {
    var b = E.emptyBoard();
    for (var i = 0; i < k; i++) { b[moves[i].x][moves[i].y] = moves[i].color; }
    return b;
  }
  function sideName(color) { return color === 1 ? '黑' : '白'; }

  function renderBoard() {
    /* viewAt 口径同两个象棋复盘：viewAt = 已应用到的着法序号（0 起），null = 终局。
       shown = 已应用的着法数；cue = plies[viewAt]，棋盘 = 该手之后的局面 */
    var shown = viewAt === null ? moves.length : viewAt + 1;
    var view = boardAt(shown);
    var cue = shown > 0 ? plies[shown - 1] : null;
    /* 终局五连高亮：只在看到最后一手时找一次连线（回看中途不算） */
    var winCells = null;
    if (cue && shown === moves.length && moves.length) {
      var last = moves[moves.length - 1];
      var win = E.checkWin(view, last.x, last.y);
      if (win) { winCells = win.cells; }
    }
    var cells = UI.board.children;
    for (var i = 0; i < cells.length; i++) {
      var cell = cells[i];
      var x = i % N, y = (i / N) | 0;
      var v = view[x][y];
      var stone = cell.firstChild;
      if (v) {
        stone.className = 'st-wz-stone ' + (v === 1 ? 'st-wz-black' : 'st-wz-white');
        cell.classList.add('is-filled');
      } else {
        stone.className = 'st-wz-stone';
        cell.classList.remove('is-filled');
      }
      cell.classList.toggle('is-last', !!cue && cue.x === x && cue.y === y);
      var isWin = false, k;
      if (winCells) {
        for (k = 0; k < winCells.length; k++) {
          if (winCells[k].x === x && winCells[k].y === y) { isWin = true; break; }
        }
      }
      cell.classList.toggle('is-win', isWin);
    }
    /* 落子声只在「回看位置变了」时响：renderAll 会被计时器、分析完成等各种
       原因反复调用，逢 cue 必响会把一次点击放大成一串声音 */
    if (cue && lastCued !== viewAt) { lastCued = viewAt; SFX.stone(cue.mover === 1 ? 240 : 190); }
    else if (!cue) { lastCued = null; }
  }

  /* ---------- 音效（轻落子声，偏好共用对战页的 study-chess-sound） ---------- */
  /* 手机外放响度补偿（口径统一，由 scripts/boost-sfx-mobile.mjs 批量写入）：
     手机小喇叭对 500Hz 以下钝感、超短音感知响度低——触屏设备把提示音增益翻倍、
     低于 500Hz 的音移高八度、衰减拉长；桌面/耳机维持原响度。 */
  var SFX_MOBILE = false;
  try {
    SFX_MOBILE = (global.matchMedia && global.matchMedia('(pointer: coarse)').matches) ||
      (global.navigator && global.navigator.maxTouchPoints > 0);
  } catch (e) { /* 检测不可用按桌面处理 */ }
  var SFX = (function () {
    var AC = null;
    function ok() {
      try { return (global.localStorage || {}).getItem('study-chess-sound') !== 'off'; } catch (e) { return true; }
    }
    function stone(freq) {
      if (!ok()) { return; }
      try {
        var ACtor = global.AudioContext || global.webkitAudioContext;
        if (!ACtor) { return; }
        if (!AC) { AC = new ACtor(); }
        if (AC.state === 'suspended' && AC.resume) { AC.resume(); }
        var t = AC.currentTime;
        var o = AC.createOscillator();
        var g = AC.createGain();
        o.type = 'triangle';
        o.frequency.setValueAtTime(SFX_MOBILE && freq < 500 ? freq * 2 : freq, t);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(SFX_MOBILE ? 0.4 : 0.18, t + 0.008);
        g.gain.exponentialRampToValueAtTime(0.0001, t + (SFX_MOBILE ? 0.18 : 0.12));
        o.connect(g); g.connect(AC.destination);
        o.start(t); o.stop(t + (SFX_MOBILE ? 0.22 : 0.14));
      } catch (e) { /* 音频不可用静默 */ }
    }
    return { stone: stone };
  })();

  /* ---------- 行子列表（黑方/白方两列，口径同对战页与两个象棋复盘） ---------- */
  function el(tag, cls, text) {
    var n = doc.createElement(tag);
    if (cls) { n.className = cls; }
    if (text != null) { n.textContent = text; }
    return n;
  }
  function span(cls, text) { return el('span', cls, text); }
  function renderMoves() {
    var box = UI.moves;
    box.textContent = '';
    if (!plies.length) { return; }
    var head = el('li', 'st-move-row st-move-row--head');
    head.appendChild(span('st-move-no', '#'));
    head.appendChild(span('st-move-col', '黑方'));
    head.appendChild(span('st-move-col', '白方'));
    box.appendChild(head);
    for (var i = 0; i < plies.length; i += 2) {
      var row = el('li', 'st-move-row');
      row.appendChild(span('st-move-no', (i / 2 + 1) + '.'));
      for (var k = 0; k < 2; k++) {
        var idx = i + k;
        if (idx >= plies.length) { row.appendChild(el('span', 'st-move-ply')); continue; }
        var p = plies[idx];
        var b = el('button', 'st-move-ply');
        b.type = 'button';
        b.textContent = p.coord;
        b.setAttribute('data-ply', String(idx));
        if (p.loss >= REPORT_MIN) { b.className += ' is-lose'; }
        if (viewAt === idx) { b.className += ' is-cur'; }
        b.title = (p.mover === 1 ? '黑方 · ' : '白方 · ') + phrasesText(p);
        b.addEventListener('click', onPly);
        row.appendChild(b);
      }
      box.appendChild(row);
    }
  }
  function onPly(e) {
    if (replayTimer) { stopReplay(); }
    var idx = Number(e.currentTarget.getAttribute('data-ply'));
    viewAt = (idx === plies.length - 1 || viewAt === idx) ? null : idx;
    renderAll();
  }
  function stepPly(dir) {
    if (!analyzed) { return; }
    stopReplay();
    var d = viewAt === null ? plies.length - 1 : viewAt;
    var n = d + dir;
    if (n < 0) { return; }
    viewAt = (n >= plies.length - 1) ? null : n;
    renderAll();
  }

  /* 「回放这局」：0.75 秒/手从开局重演（口径同对战页）；再点 = 停止并回到终局 */
  function stopReplay() {
    if (replayTimer) { global.clearInterval(replayTimer); replayTimer = null; }
    if (UI.replayLabel) { UI.replayLabel.textContent = '回放这局'; }
  }
  function toggleReplay() {
    if (!analyzed) { return; }
    if (replayTimer) { stopReplay(); renderAll(); return; }
    viewAt = 0;
    renderAll();
    replayTimer = global.setInterval(function () {
      if (viewAt === null || viewAt >= plies.length - 1) { stopReplay(); viewAt = null; renderAll(); return; }
      viewAt++;
      renderAll();
    }, 750);
    if (UI.replayLabel) { UI.replayLabel.textContent = '停止回放'; }
  }

  /* ---------- 状态 / 按钮（无评估条：威胁分换算胜率是伪精确，见文件头） ---------- */
  function renderStatus() {
    var box = UI.viewStatus;
    if (analyzing) { box.textContent = '分析中……'; return; }
    if (!analyzed) {
      box.textContent = '还没有分析结果：粘入棋谱点「开始分析」，或从对战页点「复盘这一局」过来。';
      return;
    }
    if (replayTimer) {
      box.textContent = '回放中：重演到第 ' + (viewAt + 1) + ' / ' + plies.length + ' 手。';
      return;
    }
    if (viewAt !== null) {
      var p = plies[viewAt];
      box.textContent = '回看第 ' + (viewAt + 1) + ' / ' + plies.length + ' 手（'
        + (p.mover === 1 ? '黑方' : '白方') + ' ' + p.coord + '）之后的局面。';
      return;
    }
    var last = plies[plies.length - 1];
    box.textContent = '终局：共 ' + plies.length + ' 手'
      + (last && last.winSide ? '——' + (last.mover === 1 ? '黑方' : '白方') + '五连获胜' : '')
      + '。点行子或结论条目回看。';
  }
  function renderButtons() {
    var ready = analyzed && !analyzing;
    var d = viewAt === null ? plies.length - 1 : viewAt;
    UI.prev.disabled = !ready || d <= 0;
    UI.next.disabled = !ready || viewAt === null;
    UI.replay.disabled = !ready || plies.length === 0;
    UI.analyze.disabled = analyzing;
    if (UI.reportCopy) { UI.reportCopy.disabled = !ready; }
    if (UI.reportDownload) { UI.reportDownload.disabled = !ready; }
  }

  /* ---------- 复盘结论：亏分按威胁档位说人话 ---------- */
  /* 返回已带单位的分数文本：≥1 万缩写成「X 万分」，其余直接报分。
     不要输出「X 千」让模板再拼「分」——拼出来是「4305 千 分」，
     会被读成「千分」这个不存在的单位。 */
  function scoreText(n) {
    n = Math.round(n);
    if (n >= 10000) { return Math.round(n / 1000) / 10 + ' 万分'; }
    return n + ' 分';
  }
  function lossText(p) {
    /* 进攻亏 = 自己的机会没抓住，防守亏 = 对手的威胁没堵住。
       档位边界跟着量纲走：冲四档下限取冲四与活三的中点（7.5 万），活三档与结论
       门槛（REPORT_MIN）对齐——漏堵活三（5 万）必须落进「活三」而不是「冲四」。
       大额分差只可能是这两种：连五那步的分差为 0 或为正，不会进这里。 */
    if (p.loss <= 0) { return '没亏'; }
    var a = p.whySide === 'attack';
    if (p.loss >= SCORES.FIVE / 2) { return a ? '能直接连五取胜的一手没下' : '没挡住对手连五'; }
    if (p.loss >= SCORES.LIVE_FOUR / 2) { return a ? '自己的活四没下' : '没堵住对手的活四'; }
    if (p.loss >= SCORES.RUSH_FOUR - SCORES.LIVE_THREE / 2) { return a ? '自己的冲四没走' : '没堵住对手的冲四'; }
    if (p.loss >= REPORT_MIN) { return a ? '自己的活三没搭' : '没堵住对手的活三'; }
    return '亏约 ' + scoreText(p.loss);
  }
  function classify(loss) {
    if (loss >= KIND_MIN.blunder) { return 'blunder'; }
    if (loss >= KIND_MIN.mistake) { return 'mistake'; }
    if (loss >= KIND_MIN.inaccuracy) { return 'inaccuracy'; }
    return null;
  }
  function firstPhrase(p) {
    var ph = p.explain || [];
    if (!ph.length) {
      if (p.loss >= REPORT_MIN) { return '这一手亏在别处更大的点——看引擎建议那格'; }
      return '平静的一手，威胁格局基本没变';
    }
    return ph[0];
  }
  function phrasesText(p) {
    var ph = p.explain || [];
    return lossText(p) + '：' + (ph.length ? ph.join('；') : '平静的一手，威胁格局基本没变');
  }
  function renderReport() {
    var listBox = UI.reportList;
    listBox.textContent = '';
    if (!analyzed) {
      UI.reportCounts.textContent = analyzing ? '分析中……' : '分析完成后出结论。';
      return;
    }
    var count = { b: { blunder: 0, mistake: 0 }, w: { blunder: 0, mistake: 0 } };
    var worst = null;
    for (var i = 0; i < plies.length; i++) {
      var p = plies[i];
      if (p.loss >= REPORT_MIN && count[p.mover === 1 ? 'b' : 'w'][p.kind] !== undefined) {
        count[p.mover === 1 ? 'b' : 'w'][p.kind]++;
      }
      if (!worst || p.loss > worst.loss) { worst = p; }
    }
    var turnLine = '黑方：漏着 ' + count.b.blunder + ' · 错着 ' + count.b.mistake
      + '　白方：漏着 ' + count.w.blunder + ' · 错着 ' + count.w.mistake;
    if (worst && worst.loss >= REPORT_MIN) {
      turnLine += '　转折在第 ' + (plies.indexOf(worst) + 1) + ' 手（'
        + sideName(worst.mover) + ' ' + worst.coord + '）';
    } else {
      turnLine += '　双方都没走出明显亏分的着法';
    }
    UI.reportCounts.textContent = turnLine;
    var any = false;
    for (var j = 0; j < plies.length; j++) {
      var p2 = plies[j];
      if (p2.loss < REPORT_MIN) { continue; }
      any = true;
      var li = el('li', 'st-report-item');
      var btn = el('button', 'st-report-btn');
      btn.type = 'button';
      btn.appendChild(span('st-report-no', (j + 1) + '.'));
      btn.appendChild(span('st-report-san', (p2.mover === 1 ? '黑' : '白') + p2.coord));
      btn.appendChild(span('st-report-loss' + (p2.loss >= KIND_MIN.blunder ? ' st-report-loss--big' : ''), lossText(p2)));
      btn.appendChild(span('st-report-why', firstPhrase(p2)));
      btn.addEventListener('click', (function (idx) {
        return function () {
          stopReplay();
          viewAt = (idx === plies.length - 1) ? null : idx;
          renderAll();
        };
      })(j));
      li.appendChild(btn);
      li.appendChild(buildSuggestion(j, p2));   // 「该走哪」：建议着 + 备选 + 参考变化
      listBox.appendChild(li);
    }
    if (!any) {
      var empty = el('li', 'st-report-empty');
      empty.textContent = '没有亏到活三级以上的着法——至少在这个引擎眼里下得干净。';
      listBox.appendChild(empty);
    }
  }

  /* ---------------- 「该走哪」：建议着 + 备选 + 参考变化（口径同两个象棋复盘） ----------------
     数据与分差出自同一份计算（rankMoves 榜单）；变化线点开才算，算过就缓存。 */
  function buildSuggestion(j, p) {
    var box = el('div', 'st-report-best');
    var best = bests[j];
    if (best) {
      if (best.coord === p.coord) {
        // 你走的恰是榜首，分差来自点评估求和的噪声——如实说，不让人白改
        box.appendChild(span('st-report-best-line', '引擎也选了这一手——上面的分差多半是噪声，不用改。'));
      } else {
        box.appendChild(span('st-report-best-line', '引擎建议：' + best.coord));
        var alts = [];
        var topsList = tops[j] || [];
        for (var i = 0; i < topsList.length && alts.length < 2; i++) {
          var t = topsList[i];
          if (t.coord !== best.coord && t.coord !== p.coord) {
            alts.push(t.coord + '（差 ' + scoreText(t.gap) + '）');
          }
        }
        if (alts.length) { box.appendChild(span('st-report-alt', '备选：' + alts.join('、'))); }
      }
    } else {
      box.appendChild(span('st-report-best-line', '终局局面：没有建议着。'));
    }
    /* 参考变化：双方各按榜首走两手（共 4 手），点开才算，算过就缓存。
       五子棋没有深算「最强应对」——这条线如实叫参考变化，浅层延伸不冒充证明。 */
    var pvBtn = el('button', 'st-report-pv-btn');
    pvBtn.type = 'button';
    var pvLine = el('span', 'st-report-pv-line');
    function pvText(line) { return line.length ? line.join(' ') : '变化算不出'; }
    if (pvs[j]) {
      pvLine.textContent = pvText(pvs[j]);
      pvLine.hidden = !pvs[j].length;
      pvBtn.textContent = pvs[j].length ? '收起变化' : '变化算不出';
      pvBtn.disabled = !pvs[j].length;   // 算不出变化的按钮置灰，不再可点
    } else {
      pvLine.hidden = true;
      pvBtn.textContent = '看变化';
    }
    pvBtn.addEventListener('click', function () {
      if (pvs[j]) {
        if (!pvs[j].length) { return; }
        pvLine.hidden = !pvLine.hidden;
        pvBtn.textContent = pvLine.hidden ? '看变化' : '收起变化';
        return;
      }
      pvBtn.disabled = true;
      pvBtn.textContent = '算变化中……';
      var epoch = plies.length;   // 20ms 内可能已开新一轮分析：局面换了就丢弃，别写错局的数据
      global.setTimeout(function () {
        if (epoch !== plies.length || analyzing || !analyzed) { return; }
        var line = pvLineOf(j);
        pvs[j] = line;
        pvBtn.disabled = false;
        pvLine.textContent = pvText(line);
        pvLine.hidden = !line.length;
        pvBtn.textContent = line.length ? '收起变化' : '变化算不出';
      }, 20);
    });
    box.appendChild(pvBtn);
    box.appendChild(pvLine);
    return box;
  }
  /* 从第 j 手之前的局面起，双方交替走榜首，共 4 手（2 回合）——纯点评估，瞬时完成 */
  function pvLineOf(j) {
    var b = boardAt(j);
    var out = [];
    var color = 1;
    for (var i = 0; i < 4; i++) {
      var ranked = rankMoves(b, color);
      if (!ranked.length) { break; }
      var mv = ranked[0];
      b[mv.x][mv.y] = color;
      out.push((color === 1 ? '黑' : '白') + mv.coord);
      color = color === 1 ? 2 : 1;
    }
    return out;
  }

  /* ---------------- 教练的话（本地聚合，句句有据；不接任何大模型） ----------------
     与象棋复盘同一思路：把亏分按阶段、进攻/防守、分档聚合，固定模板生成。
     五子棋的「原因」按亏分分量拆：防守亏 = 对手的威胁没堵住，进攻亏 = 自己的机会没抓住。 */
  var PHASE_CN = ['前段', '中段', '后段'];
  function coachStats() {
    var n = plies.length;
    var b1 = Math.max(1, Math.round(n / 3)), b2 = Math.max(b1 + 1, Math.round(n * 2 / 3));
    function mk() {
      return { blunder: 0, mistake: 0, loss: 0, defend: 0, attack: 0, phLoss: [0, 0, 0], phCnt: [0, 0, 0], worst: null, worstIdx: -1 };
    }
    var st = { 1: mk(), 2: mk() };
    for (var i = 0; i < plies.length; i++) {
      var p = plies[i];
      if (p.loss < REPORT_MIN) { continue; }
      var s = st[p.mover];
      if (!s) { continue; }
      if (p.kind === 'blunder') { s.blunder++; } else if (p.kind === 'mistake') { s.mistake++; }
      s.loss += p.loss;
      if (p.whySide === 'defend') { s.defend++; } else { s.attack++; }
      var ph = i < b1 ? 0 : (i < b2 ? 1 : 2);
      s.phCnt[ph]++; s.phLoss[ph] += p.loss;
      if (!s.worst || p.loss > s.worst.loss) { s.worst = p; s.worstIdx = i; }
    }
    return st;
  }
  function buildCoach() {
    var st = coachStats();
    var entries = st[1].blunder + st[1].mistake + st[2].blunder + st[2].mistake;
    var lines = [];
    if (!entries) {
      lines.push('这盘棋在这个引擎眼里下得很干净：双方都没有亏到活三级以上的着法。'
        + '能把平静的局面走得稳，本身就是功夫——想再进一步，拿一盘输给更强对手的棋来复盘，收获更大。');
      return lines;
    }
    /* 总评：谁的亏分重、集中在哪一段（thirds 分段如实叫前/中/后段，不冒充开局残局理论） */
    var more = st[1].loss >= st[2].loss ? 1 : 2;
    var other = more === 1 ? 2 : 1;
    var sM = st[more], sO = st[other];
    var phase = 0;
    for (var i = 1; i < 3; i++) { if (sM.phLoss[i] > sM.phLoss[phase]) { phase = i; } }
    var openers = ['先说最要紧的：', '整盘扫完，结论是：', '这盘棋的账是这样的：'];
    lines.push(openers[plies.length % openers.length] + sideName(more) + '方一共亏了约 '
      + scoreText(sM.loss) + '，比' + sideName(other) + '方（约 ' + scoreText(sO.loss)
      + '）重；亏分最集中在' + PHASE_CN[phase]
      + (sM.phCnt[phase] > 1 ? '，' + sM.phCnt[phase] + ' 处里占了大头' : '') + '。');
    /* 反复出现的问题：漏防（对手的威胁没堵住）优先讲——五子棋输棋多半输在这 */
    if (sM.defend >= 2 && sM.defend >= sM.attack) {
      lines.push('这些亏分里最扎眼的是「漏防」——' + sM.defend + ' 处对手的威胁没堵住。'
        + '五子棋的攻防常常就在一两个点上：轮到自己时，先看对手能不能连成三、连成四，再想自己的连法。');
    } else if (sM.attack >= 2) {
      lines.push('这些亏分里有 ' + sM.attack + ' 处是自己的连子机会没抓住——'
        + '轮到你的时候，先数一遍四个方向：有成五走成五，有活四走活四，然后才轮到别的。');
    } else if (sM.worst) {
      var best = bests[sM.worstIdx];
      lines.push('最值得重摆的是第 ' + (sM.worstIdx + 1) + ' 手的 ' + sM.worst.coord
        + (best && best.coord !== sM.worst.coord ? '——引擎建议走 ' + best.coord : '')
        + '。把那一手前后多看两眼，胜过把整盘重下三遍。');
    }
    /* 亮点：只夸数据撑得住的 */
    var praise = [];
    if (sO.blunder === 0) { praise.push(sideName(other) + '方整盘没有漏着，稳定性值得保持'); }
    if (sO.loss > 0 && sO.phCnt[2] === 0) { praise.push(sideName(other) + '方后段一手都没亏，越下越稳'); }
    if (praise.length) { lines.push('好消息也有：' + praise.join('；') + '。'); }
    lines.push('复盘不是找罪受：从错着清单里挑一条，按「引擎建议」摆一遍——下一盘改掉一件事，就算这趟复盘没白做。');
    return lines;
  }
  function renderCoach() {
    if (!UI.coach) { return; }
    if (!analyzed) { UI.coach.hidden = true; UI.coach.textContent = ''; return; }
    var lines = buildCoach();
    UI.coach.textContent = '';
    UI.coach.appendChild(el('h4', 'st-coach-title', '教练的话'));
    for (var i = 0; i < lines.length; i++) { UI.coach.appendChild(el('p', 'st-coach-line', lines[i])); }
    UI.coach.hidden = false;
  }

  /* ---------------- 报告导出（复制 / 下载 .txt） ---------------- */
  function reportText() {
    var L = [];
    var count = { 1: { blunder: 0, mistake: 0 }, 2: { blunder: 0, mistake: 0 } };
    var worst = null, worstIdx = -1;
    for (var i = 0; i < plies.length; i++) {
      var p = plies[i];
      if (p.loss >= REPORT_MIN && count[p.mover][p.kind] !== undefined) { count[p.mover][p.kind]++; }
      if (!worst || p.loss > worst.loss) { worst = p; worstIdx = i; }
    }
    L.push('学习乐园 · 五子棋复盘报告');
    L.push('生成时间：' + new Date().toLocaleString());
    L.push('规模：' + plies.length + ' 手（本地引擎分析，棋谱未上传）');
    L.push('黑方：漏着 ' + count[1].blunder + ' · 错着 ' + count[1].mistake
      + '　白方：漏着 ' + count[2].blunder + ' · 错着 ' + count[2].mistake);
    if (worst && worst.loss >= REPORT_MIN) {
      L.push('转折：第 ' + (worstIdx + 1) + ' 手（' + sideName(worst.mover) + ' ' + worst.coord + '）');
    }
    L.push('');
    L.push('—— 错着清单 ——');
    for (var j = 0; j < plies.length; j++) {
      var p2 = plies[j];
      if (p2.loss < REPORT_MIN) { continue; }
      L.push('第 ' + (j + 1) + ' 手 ' + sideName(p2.mover) + ' ' + p2.coord
        + '：' + lossText(p2) + (p2.kind ? '（' + KIND_CN[p2.kind] + '）' : ''));
      var ph = p2.explain || [];
      if (ph.length) { L.push('  这一手：' + ph.join('；')); }
      var best = bests[j];
      if (best && best.coord !== p2.coord) {
        L.push('  引擎建议：' + best.coord);
        var topsList = tops[j] || [];
        var alts = [];
        for (var k = 0; k < topsList.length && alts.length < 2; k++) {
          var t = topsList[k];
          if (t.coord !== best.coord && t.coord !== p2.coord) { alts.push(t.coord + '（差 ' + scoreText(t.gap) + '）'); }
        }
        if (alts.length) { L.push('  备选：' + alts.join('、')); }
      }
      if (pvs[j] && pvs[j].length) { L.push('  参考：' + pvs[j].join(' ')); }
    }
    L.push('');
    L.push('—— 教练的话 ——');
    var coach = buildCoach();
    for (var c = 0; c < coach.length; c++) { L.push(coach[c]); }
    L.push('');
    L.push('口径：本地引擎按威胁档位（成五/活四/冲四/活三）给每个点打分，'
      + '分差 = 最优点的综合分 − 实际那手的综合分；报告只把亏到活三级以上的当结论。');
    return L.join('\n');
  }
  function fileStamp() {
    var d = new Date();
    function p2(n) { return (n < 10 ? '0' : '') + n; }
    return d.getFullYear() + p2(d.getMonth() + 1) + p2(d.getDate()) + '-' + p2(d.getHours()) + p2(d.getMinutes());
  }
  function copyReport() {
    if (!analyzed || analyzing) { return; }
    var text = reportText();
    var fail = function () {
      var ta = doc.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      doc.body.appendChild(ta);
      ta.select();
      try { ta.setSelectionRange(0, text.length); } catch (e2) { /* 老浏览器无所谓 */ }
      var okCopy = false;
      try { okCopy = doc.execCommand('copy'); } catch (e3) { okCopy = false; }
      /* execCommand 被拒时返回 false 而不抛异常，必须看返回值，否则明明没复制成功也说复制了 */
      setStatus(okCopy ? '报告已复制，去粘贴吧。' : '复制被浏览器拦了——试试「下载报告」。');
      doc.body.removeChild(ta);
    };
    if (global.navigator && global.navigator.clipboard && global.navigator.clipboard.writeText) {
      global.navigator.clipboard.writeText(text).then(function () { setStatus('报告已复制，去粘贴吧。'); }, fail);
    } else { fail(); }
  }
  function downloadReport() {
    if (!analyzed || analyzing) { return; }
    var blob = new Blob([reportText()], { type: 'text/plain;charset=utf-8' });
    var a = doc.createElement('a');
    a.href = global.URL.createObjectURL(blob);
    a.download = '学习乐园-五子棋复盘-' + fileStamp() + '.txt';
    doc.body.appendChild(a);
    a.click();
    doc.body.removeChild(a);
    global.setTimeout(function () { global.URL.revokeObjectURL(a.href); }, 2000);
    setStatus('报告已下载成 .txt——存档、发群都行。');
  }

  /* ---------------- 最近复盘的棋局（本机最近 5 盘，载入即回看） ---------------- */
  function renderGames() {
    if (!UI.games || !UI.gamesList) { return; }
    var list = loadHistory();
    if (UI.gamesCount) { UI.gamesCount.textContent = list.length ? String(list.length) : ''; }
    disarmDel();
    UI.gamesList.textContent = '';   // 先清旧条目：删掉最后一条后不留过期 DOM
    if (!list.length) { UI.games.hidden = true; return; }
    UI.games.hidden = false;
    for (var i = 0; i < list.length; i++) {
      (function (entry, idx) {
        var li = el('li', 'st-games-item');
        var d = new Date(entry.t || Date.now());
        function p2(n) { return (n < 10 ? '0' : '') + n; }
        // 日期主行说人话：今天/昨天用相对词，更早回退「9月28日」——比 10-1 这种数字串好读。
        // 按日历日判断而不是 24 小时差：凌晨的棋到上午打开也该算「昨天」
        var now = new Date();
        var day0 = function (x) { return new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime(); };
        var diff = Math.round((day0(now) - day0(d)) / (24 * 3600 * 1000));
        var hm = p2(d.getHours()) + ':' + p2(d.getMinutes());
        var when;
        if (diff <= 0) { when = '今天 ' + hm; }
        else if (diff === 1) { when = '昨天 ' + hm; }
        else { when = (d.getMonth() + 1) + '月' + d.getDate() + '日 ' + hm; }
        // 主副两层：日期时间是扫读主键（深色），「走了 N 手」是次要信息（浅色小字）
        var label = el('span', 'st-games-label');
        label.appendChild(span('st-games-date', when));
        label.appendChild(span('st-games-meta', '走了 ' + (entry.moves || []).length + ' 手'));
        li.appendChild(label);
        // 整条可点：点条目任意处加载（鼠标点「加载」/ 键盘 Enter 都靠 click 冒泡到这里，不重复绑）；
        // 删除按钮有自己的语义，stopPropagation 拦住不让它顺带触发载入
        li.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('.st-games-del')) { return; }
          loadHistoryGame(idx);
        });
        var btn = el('button', 'st-games-open');
        btn.type = 'button';
        btn.textContent = '加载';
        btn.setAttribute('aria-label', '加载 ' + when + ' 的那盘棋');
        li.appendChild(btn);
        var del = el('button', 'st-games-del');
        del.type = 'button';
        del.textContent = '删除';
        del.setAttribute('data-aria-rest', '删除 ' + when + ' 那盘的本机记录');
        del.setAttribute('aria-label', del.getAttribute('data-aria-rest'));
        del.addEventListener('click', function (e) {
          e.stopPropagation();
          if (armedDel === del) { disarmDel(); removeHistoryGame(idx); return; }
          disarmDel();
          armedDel = del;
          del.textContent = '确认删除？';
          del.classList.add('st-games-del--armed');
          del.setAttribute('aria-label', '再点一次确认：' + del.getAttribute('data-aria-rest'));
          armedDelTimer = setTimeout(disarmDel, 3000);
        });
        li.appendChild(del);
        UI.gamesList.appendChild(li);
      })(list[i], i);
    }
  }
  function loadHistoryGame(idx) {
    if (analyzing) { return; }
    var entry = loadHistory()[idx];
    if (!entry || !entry.moves || !entry.losses) {
      setStatus('这一条记录缺了亏分数据（可能是很早版本的存档），载不了——把那盘棋谱重新粘进来分析一次就好。');
      return;
    }
    stopReplay();
    if (!buildFromCoordLoss(entry.moves, entry.losses)) {
      setStatus('这一盘的存档与规则对不上（可能被改动过），载不了。');
      return;
    }
    UI.pgn.value = textFromMoves();
    savedNote = '已加载最近的一盘（' + plies.length + ' 手）。粘入新棋谱可重新分析。';
    renderAll();
  }
  /** 删除做内联两步确认：第一击按钮就地变「确认删除？」，再击才真删，3 秒不动自动复位。
      误删的代价是整段本机分析记录，弹窗太重、一点就删太轻。armed 状态随重渲染/换目标清掉。 */
  var armedDel = null;
  var armedDelTimer = 0;
  function disarmDel() {
    if (armedDelTimer) { clearTimeout(armedDelTimer); armedDelTimer = 0; }
    if (armedDel) {
      armedDel.textContent = '删除';
      armedDel.classList.remove('st-games-del--armed');
      armedDel.setAttribute('aria-label', armedDel.getAttribute('data-aria-rest') || '');
      armedDel = null;
    }
  }
  /** 删除「最近复盘的棋局」里的一条——只删本机记录，不影响当前画布与已下载的报告；须经内联确认后调用 */
  function removeHistoryGame(idx) {
    if (analyzing) { return; }
    var list = loadHistory();
    if (idx < 0 || idx >= list.length) { return; }
    list.splice(idx, 1);
    try { global.localStorage.setItem(HIST_KEY, JSON.stringify(list)); } catch (e) { /* 存不进就算了 */ }
    renderGames();
  }
  function renderAll() {
    renderBoard();
    renderMoves();
    renderStatus();
    renderButtons();
    renderReport();
    renderCoach();
    renderGames();
    if (savedNote) {
      UI.savedNote.hidden = false;
      UI.savedNote.textContent = savedNote;
      savedNote = '';
    }
    var cur = UI.moves.querySelector('.is-cur');
    if (cur && cur.scrollIntoView) { cur.scrollIntoView({ block: 'nearest' }); }
  }

  /* ---------------- 棋盘解析 ----------------
   * 支持三种写法（可混排），口径见页首注释：
   *   1) 导出/移交格式：`1. 黑 H8`——一行一手，颜色词只是给人读的，权威是序号步序；
   *   2) 纯坐标行：`H8`（无序号也认）、`H8-I9`、`h8i9`；
   *   3) 一行多手：`1. 黑 H8 白 I9`。
   * 表头/说明行（读不出坐标的行）一律跳过；落点与规则不符（出界/已有子）立即报错指明第几手。 */
  function normCoord(text) {
    var m = /^([a-oA-O])\s*([0-9]{1,2})$/.exec(String(text || '').trim());
    if (!m) { return null; }
    var x = FILES.indexOf(m[1].toUpperCase());
    var y = parseInt(m[2], 10) - 1;
    if (x < 0 || y < 0 || y >= N) { return null; }
    return { x: x, y: y };
  }
  function parseScoreText(text) {
    var out = [];
    var b = E.emptyBoard();
    var lines = String(text || '').replace(/\u00a0/g, ' ')
      /* 全角字母数字归一成半角：手机输入法常打出「Ｊ１０」，不归一会被当说明文字吞掉，
         之后所有手按步序黑白错位，分析还「成功」——这是最阴的错法 */
      .replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (ch) { return String.fromCharCode(ch.charCodeAt(0) - 0xFEE0); })
      .split(/\r?\n/);
    function take(coordText, raw) {
      var pt = normCoord(coordText);
      if (!pt) { return '棋谱第 ' + (out.length + 1) + ' 手（' + raw + '）读不出合法坐标，分析中止。'; }
      if (b[pt.x][pt.y] !== 0) {
        return '棋谱第 ' + (out.length + 1) + ' 手（' + E.coordName(pt.x, pt.y) + '）与规则不符：这个点已有子，分析中止。';
      }
      var color = out.length % 2 === 0 ? 1 : 2;   // 权威是步序：第 1 手黑、第 2 手白……
      b[pt.x][pt.y] = color;
      out.push({ x: pt.x, y: pt.y, color: color });
      return null;
    }
    for (var li = 0; li < lines.length; li++) {
      var line = lines[li].trim();
      if (!line) { continue; }
      var body = line.replace(/^\d+\s*[.、．]\s*/, '');
      /* 整行是一对坐标：H8-I9 / H8 I9 / h8i9 */
      var bare = /^([a-oA-O])\s*(\d{1,2})\s*[-–—~]?\s*([a-oA-O])\s*(\d{1,2})$/.exec(body);
      if (bare) {
        var err = take(bare[1] + bare[2], body);
        if (err) { return { moves: null, error: err }; }
        var err2 = take(bare[3] + bare[4], body);
        if (err2) { return { moves: null, error: err2 }; }
        continue;
      }
      /* 逐段吃坐标词：`黑 H8`、`白I9`、`H8`（混着来也认）；一行可有多手 */
      var segs = body.split(/[\s,，、;；。．]+/);
      for (var si = 0; si < segs.length; si++) {
        var seg = segs[si];
        if (!seg) { continue; }
        var cm = /^(?:黑|白)?\s*([a-oA-O]\s?\d{1,2})$/.exec(seg);
        if (!cm) {
          // 像坐标却读不出（P5、Z12 这类超出 A~O 的列）：大概率是棋谱内容写错了，
          // 报错而不是吞掉——静默跳过会让后面的手整体黑白错位成另一盘棋
          if (/^(?:黑|白)?\s*[a-zA-Z]\s*\d{1,2}$/.test(seg)) {
            return { moves: null, error: '棋谱第 ' + (out.length + 1) + ' 手（' + seg + '）读不出合法坐标（列 A~O、行 1~15），分析中止。' };
          }
          continue;   // 颜色词/说明文字单独成段时跳过
        }
        var err3 = take(cm[1], seg);
        if (err3) { return { moves: null, error: err3 }; }
      }
    }
    if (!out.length) {
      return { moves: null, error: '没有读到任何着法——请粘对战页「导出」或「复制」的棋谱文本。' };
    }
    return { moves: out, error: null };
  }

  /* ---------------- 复盘口径的选点（与对战页 bestMove 同构的第一层 + 终局短路） ----------------
   * 刻意不带随机抖动（复盘要确定性）、不带展望层（结论与建议出自同一份浅计算）。
   * 综合分 s = myGain + oppGain：能成五的点、必须堵的点都会被它顶到最前。 */
  function rankMoves(board, color) {
    var opp = color === 1 ? 2 : 1;
    var cands = E.candidateMoves(board);
    var scored = [], i, p;
    for (i = 0; i < cands.length; i++) {
      p = cands[i];
      scored.push({
        x: p.x, y: p.y,
        coord: E.coordName(p.x, p.y),
        myGain: E.evalPoint(board, p.x, p.y, color),
        oppGain: E.evalPoint(board, p.x, p.y, opp)
      });
    }
    /* 终局短路（同 bestMove）：能成五直接第一；对手能成五的点必须堵（堵点里挑综合最优） */
    var winNow = null, mustBlock = [];
    for (i = 0; i < scored.length; i++) {
      if (scored[i].myGain >= SCORES.FIVE) { winNow = scored[i]; break; }
      if (scored[i].oppGain >= SCORES.FIVE) { mustBlock.push(scored[i]); }
    }
    if (winNow) { winNow.s = winNow.myGain + winNow.oppGain; return [winNow]; }
    if (mustBlock.length) {
      mustBlock.sort(function (a, b) { return (b.myGain + b.oppGain) - (a.myGain + a.oppGain); });
      for (i = 0; i < mustBlock.length; i++) { mustBlock[i].s = mustBlock[i].myGain + mustBlock[i].oppGain; }
      return mustBlock;
    }
    for (i = 0; i < scored.length; i++) { scored[i].s = scored[i].myGain + scored[i].oppGain; }
    scored.sort(function (a, b) { return b.s - a.s; });
    return scored;
  }

  /* ---------------- 分析（同步，毫秒级：点评估无深搜，见文件头） ----------------
   * scores[k] = 第 k 手之前局面里轮走方最优点的综合分；
   * 第 k 手亏损 = scores[k] − 实际那手的综合分（只记正亏），拆进攻亏/防守亏两个分量。 */
  function analyze(text, onFail) {
    if (analyzing) { return; }
    var parsed = parseScoreText(text);
    if (parsed.error) { onFail(parsed.error); return; }
    stopReplay();   // 回放计时器闭包读的是旧 plies：换局先停，防止定时器把新局拽回旧局面
    analyzing = true;
    analyzed = false;
    moves = parsed.moves;
    plies = [];
    scores = [];
    bests = []; tops = []; pvs = {};
    viewAt = null;
    setStatus('解析成功（' + moves.length + ' 手），正在逐步分析……');
    renderAll();
    try {
      /* 逐局面：榜首（建议着 + 榜单）→ 实际那手的分量 → 亏分与档位 */
      for (var k = 0; k < moves.length; k++) {
        var b = boardAt(k);
        var color = moves[k].color;
        var opp = color === 1 ? 2 : 1;
        var ranked = rankMoves(b, color);
        var top = ranked.length ? ranked[0] : null;
        var actMy = E.evalPoint(b, moves[k].x, moves[k].y, color);
        var actOpp = E.evalPoint(b, moves[k].x, moves[k].y, opp);
        var actS = actMy + actOpp;
        scores.push(top ? top.s : 0);
        bests.push(top ? { x: top.x, y: top.y, coord: top.coord } : null);
        var topsList = [];
        for (var r = 0; r < Math.min(4, ranked.length); r++) {
          topsList.push({ coord: ranked[r].coord, s: ranked[r].s, gap: top ? top.s - ranked[r].s : 0 });
        }
        tops.push(topsList);
        var loss = Math.max(0, (top ? top.s : 0) - actS);
        plies.push({
          coord: E.coordName(moves[k].x, moves[k].y),
          mover: color, x: moves[k].x, y: moves[k].y,
          explain: E.explain(b, moves[k].x, moves[k].y, color),
          loss: loss,
          kind: classify(loss),
          whySide: (top ? top.myGain - actMy : 0) >= (top ? top.oppGain - actOpp : 0) ? 'attack' : 'defend'
        });
      }
      /* 终局标记（状态行「五连获胜」与报告转折用） */
      var view = boardAt(moves.length);
      if (moves.length) {
        var last = moves[moves.length - 1];
        if (E.checkWin(view, last.x, last.y)) { plies[plies.length - 1].winSide = true; }
      }
    } catch (e) {
      /* 崩了也必须把 analyzing 复位——卡在 true 会永久禁用「开始分析」 */
      analyzing = false;
      analyzed = false;
      moves = []; plies = []; scores = []; bests = []; tops = []; pvs = {}; viewAt = null;
      setStatus('分析中途出错了（' + (e && e.message ? e.message : '未知原因') + '）。重试一次，还不行请把这份棋谱发给我们。');
      renderAll();
      return;
    }
    analyzing = false;
    analyzed = true;
    save();
    setStatus('分析完成：结论在右侧「复盘结论」，点棋盘旁的行子或结论条目回看。');
    UI.savedNote.hidden = true;   // 重新分析后「已从本机恢复」的旧提示作废
    renderAll();
  }

  /* ---------------- 存档（同两个象棋复盘：只存着法与亏分，讲解重算） ---------------- */
  function save() {
    try {
      global.localStorage.setItem(STORE_KEY, JSON.stringify({
        v: 1,
        moves: moves.map(function (m) { return [m.x, m.y]; }),
        losses: plies.map(function (p) { return p.loss; })
      }));
    } catch (e) { /* 隐身模式等存不进就算了 */ }
    saveHistory();
  }
  /* 最近棋谱：本机留最近 5 盘（坐标 + 分差，讲解载入时重算）。仍是「存本地」——
     只进这台设备的 localStorage，不上传。存不进就算了，不弹错。 */
  function saveHistory() {
    try {
      var list = loadHistory();
      var snap = {
        t: Date.now(),
        moves: moves.map(function (m) { return [m.x, m.y]; }),
        losses: plies.map(function (p) { return p.loss; })
      };
      /* 同一盘棋（着法相同）无论从哪个入口重新分析，都只留最新一条——
         只跟第一条比会漏掉「从最近复盘的棋局载入旧盘再分析」的重复（列表里出现两条同棋）。 */
      var snapStr = JSON.stringify(snap.moves);
      var kept = [];
      for (var i = 0; i < list.length; i++) {
        if (JSON.stringify((list[i] || {}).moves || []) !== snapStr) { kept.push(list[i]); }
      }
      kept.unshift(snap);
      if (kept.length > HIST_MAX) { kept.length = HIST_MAX; }
      global.localStorage.setItem(HIST_KEY, JSON.stringify(kept));
    } catch (e) { /* 同上 */ }
  }
  function loadHistory() {
    try {
      var list = JSON.parse(global.localStorage.getItem(HIST_KEY) || '[]');
      return Object.prototype.toString.call(list) === '[object Array]' ? list : [];
    } catch (e) { return []; }
  }
  /** 由坐标对 + 分差重建整局（restore 与「最近复盘的棋局」载入共用） */
  function buildFromCoordLoss(coordPairs, lossesIn) {
    var list = [];
    var b = E.emptyBoard();
    for (var i = 0; i < coordPairs.length; i++) {
      var pt = coordPairs[i];
      if (!pt || typeof pt[0] !== 'number' || typeof pt[1] !== 'number'
        || pt[0] < 0 || pt[1] < 0 || pt[0] >= N || pt[1] >= N
        || b[pt[0]][pt[1]] !== 0) { return false; }
      var color = list.length % 2 === 0 ? 1 : 2;
      b[pt[0]][pt[1]] = color;
      list.push({ x: pt[0], y: pt[1], color: color });
    }
    moves = list;
    plies = [];
    scores = [];
    bests = []; tops = []; pvs = {};
    viewAt = null;
    var view = E.emptyBoard();
    for (var k = 0; k < list.length; k++) {
      var m = list[k];
      var loss = lossesIn && typeof lossesIn[k] === 'number' ? lossesIn[k] : 0;
      /* 「该走哪」的三件套（scores/bests/tops）不进存档，这里按分析的同一份
         计算（rankMoves）逐手回填——漏了会让恢复的局所有结论都显示
         「终局局面：没有建议着」（对中盘一手是事实性错误），报告导出也缺建议。
         与 analyze() 的循环逐行同构，保证两条入口口径一致。 */
      var rk = rankMoves(view, m.color);
      var tp = rk.length ? rk[0] : null;
      scores.push(tp ? tp.s : 0);
      bests.push(tp ? { x: tp.x, y: tp.y, coord: tp.coord } : null);
      var topsList = [];
      for (var r = 0; r < Math.min(4, rk.length); r++) {
        topsList.push({ coord: rk[r].coord, s: rk[r].s, gap: tp ? tp.s - rk[r].s : 0 });
      }
      tops.push(topsList);
      /* whySide 不进存档（只存着法与亏分）：结论级亏损按重算的分量定攻防方向——
         与 explain 重算同口径，否则恢复的局「没堵住对手的活三」会被说反成进攻亏。
         平静着法（loss < 门槛）不显示攻防话术，方向无所谓。 */
      var why = 'attack';
      if (loss >= REPORT_MIN && tp) {
        var am = E.evalPoint(view, m.x, m.y, m.color);
        var ao = E.evalPoint(view, m.x, m.y, m.color === 1 ? 2 : 1);
        why = (tp.myGain - am) >= (tp.oppGain - ao) ? 'attack' : 'defend';
      }
      plies.push({
        coord: E.coordName(m.x, m.y), mover: m.color, x: m.x, y: m.y,
        explain: E.explain(view, m.x, m.y, m.color),
        loss: loss, kind: classify(loss),
        whySide: why
      });
      view[m.x][m.y] = m.color;
    }
    if (list.length) {
      var last = list[list.length - 1];
      if (E.checkWin(view, last.x, last.y)) { plies[plies.length - 1].winSide = true; }
    }
    analyzed = true;
    return true;
  }
  function restore() {
    var raw = null;
    try { raw = global.localStorage.getItem(STORE_KEY); } catch (e) { /* 同上 */ }
    if (!raw) { return false; }
    var data;
    try { data = JSON.parse(raw); } catch (e) { return false; }
    if (!data || data.v !== 1 || !data.moves || !data.moves.length) { return false; }
    if (!buildFromCoordLoss(data.moves, data.losses)) { return false; }
    savedNote = '已恢复上次的分析（' + plies.length + ' 手），可继续回看或粘入新棋谱重新分析。';
    return true;
  }
  /** 用当前着法重建一份可重新解析的棋谱文本填回输入框（恢复场景） */
  function textFromMoves() {
    var out = [];
    for (var i = 0; i < moves.length; i++) {
      out.push((i + 1) + '. ' + sideName(moves[i].color) + ' ' + E.coordName(moves[i].x, moves[i].y));
    }
    return out.join('\n');
  }

  /* ---------------- 导入与启动 ---------------- */
  function doAnalyze() {
    if (analyzing) { return; }
    var text = UI.pgn.value.replace(/\u00a0/g, ' ').trim();
    if (!text) {
      setStatus('先把棋谱文本粘进上面的框，或点「选 .txt 文件」。');
      return;
    }
    analyze(text, setStatus);
  }
  function readFile(f) {
    if (!f) { return; }
    if (!global.FileReader) { setStatus('这个浏览器不支持本地读文件，把棋谱文本直接粘进来也一样。'); return; }
    var fr = new global.FileReader();
    fr.onload = function () {
      UI.pgn.value = String(fr.result || '');
      doAnalyze();
    };
    fr.onerror = function () { setStatus('文件读不出来（可能是空文件或编码不是文本）。'); };
    fr.readAsText(f);
  }
  function pick(name) { return root.querySelector('[data-st-' + name + ']'); }
  function boot() {
    UI = {
      board: pick('board'), status: pick('status'), savedNote: pick('saved-note'),
      pgn: pick('pgn'), file: pick('file'), analyze: pick('analyze'),
      viewStatus: pick('view-status'),
      moves: pick('moves'), prev: pick('prev'), next: pick('next'),
      replay: pick('replay'), replayLabel: pick('replay-label'),
      reportCounts: pick('report-counts'), reportList: pick('report-list'),
      coach: pick('coach'), reportCopy: pick('report-copy'), reportDownload: pick('report-download'),
      games: pick('games'), gamesCount: pick('games-count'), gamesList: pick('games-list')
    };
    if (!UI.board || !UI.pgn) { return; }
    setStatus = function (msg) { UI.status.textContent = msg; };

    buildBoard();

    UI.analyze.disabled = false;
    UI.analyze.addEventListener('click', doAnalyze);
    if (UI.file) { UI.file.addEventListener('change', function (e) { readFile(e.target.files[0]); }); }
    UI.prev.addEventListener('click', function () { stepPly(-1); });
    UI.next.addEventListener('click', function () { stepPly(1); });
    UI.replay.addEventListener('click', toggleReplay);
    if (UI.reportCopy) { UI.reportCopy.addEventListener('click', copyReport); }
    if (UI.reportDownload) { UI.reportDownload.addEventListener('click', downloadReport); }

    /* 从对战页「复盘这一局」带过来的棋谱：自动填入并直接开始分析 */
    var handoff = null;
    try { handoff = global.sessionStorage.getItem(HANDOFF_KEY); } catch (e) { handoff = null; }
    if (handoff && handoff.trim()) {
      try { global.sessionStorage.removeItem(HANDOFF_KEY); } catch (e2) { /* 读得出就清，清不掉也无害 */ }
      UI.pgn.value = handoff;
      doAnalyze();
      return;
    }
    restore();
    if (analyzed) {
      UI.pgn.value = textFromMoves();
    }
    renderAll();
  }

  if (pageOn) {
    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  }

  /* ---------- 冒烟钩子（smoke-study.mjs 直调，不经过 DOM） ----------
     只暴露纯函数：解析、复盘口径选点、亏分文案与分档。
     回看/分析依赖页面状态（moves/plies），不进钩子——行为由 jsdom 跑整页覆盖。 */
  global.STWuziqiFupan = {
    parseScoreText: parseScoreText,
    rankMoves: rankMoves,
    lossText: lossText,
    classify: classify
  };
})(typeof window !== 'undefined' ? window : globalThis);
